import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { ReactSortable } from 'react-sortablejs';
import { FaSync, FaWordpress } from 'react-icons/fa'

import Header from 'components/Header';
import Character from 'components/Admin/Soundbox/Character';
import CharacterAdd from 'components/Admin/Soundbox/CharacterAdd';
import CharacterEdit from 'components/Admin/Soundbox/CharacterEdit';
import Sound from 'components/Admin/Soundbox/Sound';
import SoundAdd from 'components/Admin/Soundbox/SoundAdd';
import SoundEdit from 'components/Admin/Soundbox/SoundEdit';
import Movie from 'components/Admin/Soundbox/Movie';
import MovieAdd from 'components/Admin/Soundbox/MovieAdd';
import MovieEdit from 'components/Admin/Soundbox/MovieEdit';

import { loadSoundboxDistantData, syncDropboxSounds, sortSound, updateBlackList } from 'redux/actions';

import Paths from 'paths';

class SeeSoundbox extends Component {

    componentDidMount() {
        if(this.props.soundboxUrls.length === 0) {
            this.props.loadSoundboxDistantData(this.props.soundbox);
        }
    }

    render() {
        if(this.props.soundbox === undefined) {
            return <Redirect to={Paths.PATH_ADMIN_SHOW_SOUNDBOXS}/>
        } else {
            return (
                <section id="la-soundbox-container">
                    <Header returnLink={Paths.PATH_ADMIN_SHOW_SOUNDBOXS}/>
                    <div className={'soundbox'}>
                        <h1 className={'see-soundbox-title' + (!this.props.soundboxUrls.bannerUrl ? ' image-not-found' : '')}>
                            {this.props.soundbox.id}: {this.props.bundle.title}
                            <FaWordpress className="black-list" onClick={() => {this.props.updateBlackList(this.props.soundbox.id)}}/>
                            <FaSync className="sync" onClick={() => {this.props.syncDropboxSounds(this.props.soundbox.id)}}/>
                            <img src={this.props.soundboxUrls.bannerUrl} alt={`sound-banner-${this.props.soundbox.id}`} title={`sound-banner-${this.props.soundbox.id}`} />
                        </h1>

                        <h2>Films</h2>
                        <div className={'soundbox-grid-bar-container movie-list'}>
                            {
                                this.props.soundbox.movies.map((movie) => movie.id === +this.props.match.params.movieId ?
                                    <MovieEdit {...this.props} key={`movie_${movie.id}`} movie={movie} /> :
                                    <Movie {...this.props} key={`movie_${movie.id}`} movie={movie} />)
                            }
                            { 
                                this.props.match.path === Paths.PATH_ADMIN_ADD_MOVIE ? 
                                    <MovieAdd {...this.props}></MovieAdd> : 
                                    <NavLink to={Paths.PATH_ADMIN_ADD_MOVIE.replace(':soundboxId', this.props.soundbox.id)} className={'button-large'}>Nouveau film</NavLink>
                            }
                        </div>

                        <h2>Personnages</h2>
                        <div className={'soundbox-grid-bar-container character-list'}>
                            {
                                this.props.soundbox.characters.map((character) => (character.id) === +this.props.match.params.characterId ?
                                    <CharacterEdit {...this.props}
                                        character={character}
                                        key={`character_${character.id}`} /> :
                                    <Character {...this.props}
                                        character={character} 
                                        characterUrl={this.props.soundboxUrls.charactersUrls ? this.props.soundboxUrls.charactersUrls.find(characterUrl => characterUrl.id === character.id) : undefined}
                                        key={`character_${character.id}`} />
                                )
                            }
                            { 
                                this.props.match.path === Paths.PATH_ADMIN_ADD_CHARACTER ? 
                                    <CharacterAdd {...this.props}></CharacterAdd> : 
                                    <NavLink to={Paths.PATH_ADMIN_ADD_CHARACTER.replace(':soundboxId', this.props.soundbox.id)} className={'button-large'}>Nouveau personnage</NavLink>
                            }
                        </div>

                        <h2>Répliques</h2>
                        <ReactSortable 
                            handle=".soundbox-grid-sound-id" 
                            id={'sounds'} 
                            list={this.props.soundbox.sounds.map(sound => [sound.id])}
                            className={'soundbox-grid-sound-container'} 
                            setList={() => {}}
                            onEnd={this.onSoundDragAndDrop}>
                            {
                                this.props.soundbox.sounds.map((sound) => +sound.id === +this.props.match.params.soundId ?
                                    <SoundEdit {...this.props}
                                        sound={sound} 
                                        soundUrl={this.props.soundboxUrls.soundsUrls ? this.props.soundboxUrls.soundsUrls.find(soundUrl => soundUrl.id === sound.id) : undefined}
                                        key={`sound_${sound.id}`} /> :
                                    <Sound {...this.props}
                                        sound={sound} 
                                        imageUrl={this.props.soundboxUrls.imagesUrls ? this.props.soundboxUrls.imagesUrls.find(imageUrl => imageUrl.id === sound.id) : undefined} 
                                        soundUrl={this.props.soundboxUrls.soundsUrls ? this.props.soundboxUrls.soundsUrls.find(soundUrl => soundUrl.id === sound.id) : undefined} 
                                        key={`sound_${sound.id}`} />
                                )
                            }
                        </ReactSortable>
                        {
                            this.props.match.path === Paths.PATH_ADMIN_ADD_SOUND ? 
                                <SoundAdd {...this.props}></SoundAdd> : 
                                <NavLink to={Paths.PATH_ADMIN_ADD_SOUND.replace(':soundboxId', this.props.soundbox.id)} className={'button-large'}>Nouveau son</NavLink>
                        }
                    </div>
                </section>
            )
        }
    }

    onSoundDragAndDrop = (evt) => {
        if(evt.oldIndex !== evt.newIndex) {
            this.props.sortSound(this.props.soundbox.id, evt.oldIndex, evt.newIndex);
        }   
    };
}

const mapStateToProps = (state, ownProps) => {
    let soundbox = state.soundboxs.find(soundbox => soundbox.id === +ownProps.match.params.soundboxId);
    let soundboxUrls = state.soundboxsUrls.find(soundboxUrls => soundboxUrls.id === +ownProps.match.params.soundboxId);
    let bundle = state.bundles.find(soundbox => soundbox.id === +ownProps.match.params.soundboxId);
    return {
        soundbox: soundbox,
        soundboxUrls: soundboxUrls ? soundboxUrls : [],
        bundle: bundle,
    }
};

const mapDispatchToProps = { loadSoundboxDistantData, syncDropboxSounds, sortSound, updateBlackList };

export default connect(mapStateToProps, mapDispatchToProps)(SeeSoundbox);
